(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modal = document.querySelector('[data-popup-gallery-modal]');

    if (!modal) {
      return;
    }

    const image = modal.querySelector('[data-popup-gallery-image]');
    const count = modal.querySelector('[data-popup-gallery-count]');
    const closeButton = modal.querySelector('[data-popup-gallery-close]');
    const prevButton = modal.querySelector('[data-popup-gallery-prev]');
    const nextButton = modal.querySelector('[data-popup-gallery-next]');
    let slides = [];
    let index = 0;
    let lastTrigger = null;

    const renderSlide = () => {
      const slide = slides[index];

      if (!slide) {
        return;
      }

      image.src = slide.src;
      image.alt = slide.alt || '';
      count.textContent = `${index + 1} / ${slides.length}`;
      prevButton.hidden = slides.length < 2;
      nextButton.hidden = slides.length < 2;
    };

    const closeGallery = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('overflow-hidden');
      image.removeAttribute('src');

      if (lastTrigger) {
        lastTrigger.focus();
      }
    };

    const openGallery = (trigger) => {
      const card = trigger.closest('.popup-card');
      const data = card && card.querySelector('[data-popup-gallery-data]');

      if (!data) {
        return;
      }

      try {
        slides = JSON.parse(data.textContent);
      } catch (error) {
        slides = [];
      }

      if (!slides.length) {
        return;
      }

      index = Number(trigger.dataset.popupGalleryIndex || 0);
      lastTrigger = trigger;
      modal.hidden = false;
      document.documentElement.classList.add('overflow-hidden');
      renderSlide();
      closeButton.focus();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-popup-gallery-trigger]');

      if (trigger) {
        openGallery(trigger);
        return;
      }

      if (event.target.closest('[data-popup-gallery-close]')) {
        closeGallery();
        return;
      }

      if (event.target.closest('[data-popup-gallery-prev]')) {
        index = (index - 1 + slides.length) % slides.length;
        renderSlide();
        return;
      }

      if (event.target.closest('[data-popup-gallery-next]')) {
        index = (index + 1) % slides.length;
        renderSlide();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) {
        return;
      }

      if (event.key === 'Escape') {
        closeGallery();
      }

      if (event.key === 'ArrowLeft' && slides.length > 1) {
        index = (index - 1 + slides.length) % slides.length;
        renderSlide();
      }

      if (event.key === 'ArrowRight' && slides.length > 1) {
        index = (index + 1) % slides.length;
        renderSlide();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
